import { Component, inject, Input } from '@angular/core';
import { CreatorResponseDto } from '../../../../common/general-types/creators.dto';
import { LdgImgComponent } from '../../../../atoms/ldg-img/ldg-img.component';
import { ImageService } from '../../../../services/image/image.service';
import { FormatService } from '../../../../common/format/format.service';
import { ShortNumberPipe } from '../../../../common/pipes/short-number/short-number.pipe';
import { DecimalPipe } from '@angular/common';
import { VideoThumbnailComponent } from '../../../../atoms/video-thumbnail/video-thumbnail.component';
import { VideoFormatEnum } from '../../../../common/general-types/briefs.dto';
import { CollaboratorService } from '../../../../services/collaborator/collaborator.service';
import { GoldSearchCreatorResult, GoldSearchMatchedVideo } from '../../../creators/service/magic-search/magic-search.service';

@Component({
  selector: 'v2-recommended-creator-item',
  standalone: true,
  imports: [LdgImgComponent, ShortNumberPipe, DecimalPipe, VideoThumbnailComponent],
  templateUrl: './recommended-creator-item.component.html',
  styleUrl: './recommended-creator-item.component.css',
})
export class RecommendedCreatorItemComponent {

  VideoFormatEnum = VideoFormatEnum;

  /** Inputs */
  @Input() creatorResult!: GoldSearchCreatorResult;
  /** Inputs - END */

  /** Services */
  public imageService = inject(ImageService);
  public formatService = inject(FormatService);
  public collaboratorsService = inject(CollaboratorService);
  /** Services - END */

  get creator(): CreatorResponseDto {
    return this.creatorResult.creator as CreatorResponseDto;
  }

  isSelected(): boolean {
    const uid = this.creator?.blazeFirebaseUid;
    if (!uid) {
      return false;
    }
    return this.collaboratorsService.selectedCreators().some(
      (c: CreatorResponseDto) => c.blazeFirebaseUid === uid,
    );
  }

  selectCreator(): void {
    this.collaboratorsService.selectCreator(this.creator);
  }

  removeCreator(): void {
    this.collaboratorsService.removeCreator(this.creator);
  }

  getKudosWord(average_rating: number) {
    if (this.emptyRatings()) {
      return 'Un-rated'
    } else if (average_rating) {
      if (average_rating > 4 && average_rating <= 5) {
        return 'Excellent';
      }
      if (average_rating > 3.8 && average_rating <= 4.5) {
        return 'Great';
      }
      if (average_rating > 3 && average_rating <= 3.8) {
        return 'Good';
      }
      if (average_rating > 2 && average_rating <= 3) {
        return 'Needs Work';
      }
      else {
        return 'New to SHOUT';
      }
    }
    else {
      return 'New to SHOUT';
    }
  }


  emptyRatings(): boolean {
    const reviewsSummary = this.creatorResult?.reviews_summary;
    if (typeof reviewsSummary !== 'object' || reviewsSummary === null) {
      return false;
    }
    if (Array.isArray(reviewsSummary)) {
      return false;
    }
    if (reviewsSummary instanceof Date) {
      return false;
    }
    return Object.keys(reviewsSummary).length === 0;
  }


  getAverageViews() {
    if (this.creator && this.creator.ssCreator) {
      if (this.creator.ssCreator.instagramAverages && this.creator.ssCreator.tiktokAverages) {
        return ((this.creator.ssCreator.instagramAverages?.averageViews || 0) + (this.creator.ssCreator.tiktokAverages?.averageViews || 0)) / 2
      } else if (this.creator.ssCreator.instagramAverages) {
        return (this.creator.ssCreator.instagramAverages?.averageViews || 0)
      } else if (this.creator.ssCreator.tiktokAverages) {
        return (this.creator.ssCreator.tiktokAverages?.averageViews || 0)
      } else {
        return 0
      }
    } else {
      return 0
    }
  }

  getAvgEngaegement() {
    if (this.creator && this.creator.ssCreator) {
      if (this.creator.ssCreator.instagramAverages && this.creator.ssCreator.tiktokAverages) {
        return ((this.creator.ssCreator.instagramAverages?.averageEngagementRate || 0) + (this.creator.ssCreator.tiktokAverages?.averageEngagementRate || 0)) / 2
      } else if (this.creator.ssCreator.instagramAverages) {
        return (this.creator.ssCreator.instagramAverages?.averageEngagementRate || 0)
      } else if (this.creator.ssCreator.tiktokAverages) {
        return (this.creator.ssCreator.tiktokAverages?.averageEngagementRate || 0)
      } else {
        return 0
      }
    } else {
      return 0
    }
  }

  get matchedPreviewVideos(): GoldSearchMatchedVideo[] {
    return this.creatorResult?.evidence?.matchedVideos?.slice(0, 3) ?? [];
  }
}
